const VERIFICATION_STEPS = {
  ADD_CONTENT: 'addContent',
  GET_VERIFICATION_CODE: 'getVerificationCode',
  VERIFICATION_CODE_SENT: 'verificationCodeSent',
  VERIFICATION_SUCCESS: 'verificationSuccess',
} as const;

const MODES = {
  PHONE: 'phone',
  EMAIL: 'email',
} as const;

const SOURCES = {
  LISTING_CONTACT: 'listingContact',
  CLAIM_FEED_LISTINGS: 'claimFeedListings', // deprecated
  LISTING_CLAIMING_PATH: 'listingClaimingPath',
  ACCOUNT_EMAIL_CLAIM_LISTINGS: 'accountEmailClaimListings',
} as const;

const EMAIL_VERIFICATION_CONFIG = [
  VERIFICATION_STEPS.ADD_CONTENT,
  VERIFICATION_STEPS.VERIFICATION_CODE_SENT,
  VERIFICATION_STEPS.VERIFICATION_SUCCESS,
];

const DEFAULT_VERIFICATION_CONFIG = [
  VERIFICATION_STEPS.ADD_CONTENT,
  VERIFICATION_STEPS.GET_VERIFICATION_CODE,
  VERIFICATION_STEPS.VERIFICATION_CODE_SENT,
  VERIFICATION_STEPS.VERIFICATION_SUCCESS,
];

const PHONE_VERIFICATION_MODES = {
  SMS: 'sms',
  PHONE: 'phone',
} as const;

type VerificationType = (typeof PHONE_VERIFICATION_MODES)[keyof typeof PHONE_VERIFICATION_MODES];
type MODES_VALUES = (typeof MODES)[keyof typeof MODES];
type SOURCES_VALUES = (typeof SOURCES)[keyof typeof SOURCES];

export {
  VERIFICATION_STEPS,
  EMAIL_VERIFICATION_CONFIG,
  DEFAULT_VERIFICATION_CONFIG,
  PHONE_VERIFICATION_MODES,
  MODES,
  SOURCES,
  // TODO: conver to export type
  // @ts-expect-error
  VerificationType,
  // @ts-expect-error
  MODES_VALUES,
  // @ts-expect-error
  SOURCES_VALUES,
};
